module.exports = __webpack_public_path__ + "static/media/icon_play.7b4e2909.svg";